import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ApiEndpoint {
    
     //private baseEndpoint: string = "http://localhost:9494/digitalk-xtracking-prod"
     private baseEndpoint: string = "https://demo.digitalk.com.co/digitalk-xtracking-prod"
    userRegister(): string { return `${this.baseEndpoint}/register-user` }

    scheduleSettingList(): string { return `${this.baseEndpoint}/schedule-setting` }

}